// This file is auto-generated by "@aria-ui/cli". Do not edit this file directly.

import { registerAutocompletePopupElement, type AutocompletePopupElement, type AutocompletePopupEvents } from '@prosekit/web/autocomplete';
import { createElement, forwardRef, useCallback, useRef, type ForwardedRef, type ForwardRefExoticComponent, type HTMLAttributes, type RefAttributes, useLayoutEffect } from 'react';

/** Props for the {@link AutocompletePopup} React component. */
export interface AutocompletePopupProps {
  /**
   * Emitted when the selected value changes. Only available when multiple is
   * false.
   */
  onValueChange?: (event: AutocompletePopupEvents['valueChange']) => void;
  /**
   * Emitted when the selected values change. Only available when multiple is
   * true.
   */
  onValuesChange?: (event: AutocompletePopupEvents['valuesChange']) => void;
}

function AutocompletePopupComponent(props: AutocompletePopupProps, forwardedRef: ForwardedRef<AutocompletePopupElement>) {
  registerAutocompletePopupElement();

  const elementRef = useRef<AutocompletePopupElement>(null);
  const handlersRef = useRef<Array<((event: Event) => void) | undefined>>([]);

  const { onValueChange: e0, onValuesChange: e1, ...restProps } = props;

  useLayoutEffect(() => {
    const element = elementRef.current as Record<string, unknown> | null;
    if (!element) return;
    handlersRef.current = [e0, e1] as Array<((event: Event) => void) | undefined>;
  });

  useLayoutEffect(() => {
    const element = elementRef.current;
    if (!element) return;
    const ac = new AbortController();
    for (const [index, eventName] of ['valueChange', 'valuesChange'].entries()) {
      element.addEventListener(
        eventName,
        (event: Event) => {
          handlersRef.current[index]?.(event);
        },
        { signal: ac.signal },
      );
    }
    return () => ac.abort();
  }, []);

  const mergedRef = useCallback(
    (element: AutocompletePopupElement | null) => {
      elementRef.current = element;
      if (typeof forwardedRef === 'function') {
        forwardedRef(element);
      } else if (forwardedRef) {
        forwardedRef.current = element;
      }
    },
    [forwardedRef],
  );

  return createElement('prosekit-autocomplete-popup', { ...restProps, ref: mergedRef, suppressHydrationWarning: true });
}

/** A React component that renders an `prosekit-autocomplete-popup` custom element. */
export const AutocompletePopup: ForwardRefExoticComponent<AutocompletePopupProps & HTMLAttributes<AutocompletePopupElement> & RefAttributes<AutocompletePopupElement>> = /* @__PURE__ */ forwardRef(AutocompletePopupComponent);
